import axios from "axios"
import axiosRetry from "axios-retry"

export async function getQueryIdFromSweetESnowflake (token, endpoint, requestParams, apiFunc) {
  let path = "/Prod/PostQuery"

  const params = {
    ...requestParams
  }

  const url = endpoint + path + "?" + ( new URLSearchParams( params ) ).toString()

  const options = {
    method: "POST",
    headers: {
      "Authorization": token
    }
  }

  const request = await fetch(url, options)
  return await request.json()
}

export async function getStatusForSweetEQueryId (token, endpoint, queryId) {
  const url = endpoint + "/Prod/GetStatusForQueryId"

  const axiosClient = axios.create()
  const retryCondition = (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response.status === 504
    )
  }
  axiosRetry(axiosClient, {retries: 200, retryDelay: axiosRetry.exponentialDelay, retryCondition})

  const queryStatus = await axiosClient
    .post(url, {}, {
      headers: {
        Authorization: token
      },
      params: {
        snowflakequeryid: queryId
      }
    })

  return queryStatus.data
}

export async function setSweetEFleetInSnowflake (token, endpoint, requestParams, apiMethod) {
  let path = apiMethod

  const params = {
    ...requestParams
  }
  const url = endpoint + apiMethod + "?" + ( new URLSearchParams( params ) ).toString()

  const options = {
    method: "POST",
    headers: {
      "Authorization": token
    }
  }

  const request = await fetch(url, options)
  const queryResponse = await request.json()

  const queryId = queryResponse.queryId
  const statusUrl = endpoint + "/Prod/GetStatusForQueryId"

  const axiosClient = axios.create()
  const retryCondition = (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response.status === 504
    )
  }

  axiosRetry(axiosClient, {retries: 200, retryDelay: axiosRetry.exponentialDelay, retryCondition})
  await axiosClient
    .post(statusUrl, {}, {
      headers: {
        Authorization: token
      },
      params: {
        snowflakequeryid: queryId
      }
    })

  return queryId
}

export async function getSweetEDataFromSnowflake (token, endpoint, dataFetchUrl, requestParams) {

  const params = {
    ...requestParams
  }

  const url = endpoint + "?" + ( new URLSearchParams( params ) ).toString()

  const options = {
    method: "POST",
    headers: {
      "Authorization": token
    }
  }

  const request = await fetch(url, options)
  const queryResponse = await request.json()

  const queryId = queryResponse.queryId
  const statusUrl = dataFetchUrl + "/Prod/GetStatusForQueryId"

  const axiosClient = axios.create()
  const retryCondition = (error) => {
    return (
      axiosRetry.isNetworkOrIdempotentRequestError(error) || error.response.status === 504
    )
  }

  axiosRetry(axiosClient, {retries: 200, retryDelay: axiosRetry.exponentialDelay, retryCondition})

  await axiosClient
    .post(statusUrl, {}, {
      headers: {
        Authorization: token
      },
      params: {
        snowflakequeryid: queryId
      }
    })

  const fetchDataAt = dataFetchUrl + "/Prod/GetDataForQueryId"

  const dataRequested = await axiosClient
    .post(fetchDataAt, {}, {
      headers: {
        Authorization: token
      },
      params: {
        snowflakequeryid: queryId
      }
    })

  return {
    result: dataRequested.data,
    requested: requestParams.sqlfilename
  }
}
